import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";

import { Widget } from "../../components/widget/Widget";
import Table from "../offers/Table";
import Select from "../../components/controls/Select";
import Voucher from "./Voucher";
import Loader from "../../components/loader/Loader";

import {
	Alert,
	AppBar,
	Autocomplete,
	Box,
	Button,
	Container,
	Dialog,
	DialogContent,
	Divider,
	Grid,
	IconButton,
	Slide,
	Switch,
	TextField,
	Toolbar,
	Tooltip,
	Typography,
} from "@mui/material";
import {
	Visibility,
	Delete,
	Edit,
	Close,
	ConfirmationNumber,
	Download,
	Add,
	FileUpload,
} from "@mui/icons-material";
import { Stack } from "@mui/system";
import { DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { motion } from "framer-motion";

import {
	createVoucherBatch,
	createVoucherBatchV3,
	deleteVoucherBatch,
	getAllVoucherBatch,
	getAllVoucherBatchV3,
	getVoucherCodes,
	showLoading,
	updateVoucherBatch,
} from "../../redux/actions/voucher.actions";
import { getAllOfferings, getAllOfferingsV3 } from "../../redux/actions/offering.actions";
import { getAllSourceBusiness, getAllSourceBusinessV3 } from "../../redux/actions/sourceBusiness.actions";

import "./voucher.scss";
import { getUserDetail } from "../offers/OfferManagement";
import TotalCard from "../../components/comman/cards/TextCards";
import CommonShimmer from "../../components/comman/shimmerTable/ShimmerTable";
import { toast } from "react-hot-toast";
import CommonDataTableShimmer from "../../components/comman/shimmerTable/ShimmerTable";
import CommonDataTable from "../../components/comman/comman-table/newTable";
import useDebounce from "../../hooks/useDebounce";
import CreateCampaignCard from "../../pages/campaigns/component/CardComponent";
import MessageDialog from "../../components/comman/dialogMsg/DialogMsg";
import DuplicateCodesModal from "./DuplicateCodesTable";


const bounceAnimation = {
	whileHover: { scale: 1.3 },
	whileTap: { scale: 0.9 },
};

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ref} {...props} />;
});

const handleDownload = () => {
	// using Java Script method to get PDF file
	fetch("SampleVoucherBatch.xlsx").then((response) => {
		response.blob().then((blob) => {
			// Creating new object of PDF file
			const fileURL = window.URL.createObjectURL(blob);
			// Setting various property values
			let alink = document.createElement("a");
			alink.href = fileURL;
			alink.download = "SampleVoucherBatch.xlsx";
			alink.click();
		});
	});
};

const initialFValues = {
	brand_name: "",
	offering_id: "",
	validity: "",
	status: true,
	brand_id: ""
};

const statusToString = (object) => {
	if (object.status === true) {
		return "Active";
	} else {
		return "Inactive";
	}
};

const verifiedToString = (object) => {
	if (object.is_verified === true) {
		return "Yes";
	} else {
		return "No";
	}
};

function dateFormat(dateTime) {
	let year = dateTime.getFullYear();
	let month = "" + (dateTime.getMonth() + 1);
	if (month.length != 2) {
		month = "0" + month
	}
	let dt = "" + dateTime.getDate();
	if (dt.length != 2) {
		dt = "0" + dt
	}
	// let time = dateTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: false });
	// let result = '' + month + "/" + dt + "/" + year + " " + time
	let time = dateTime.getHours() + ":" + dateTime.getMinutes() + ":" + dateTime.getSeconds()
	let result = "" + dt + "-" + month + "-" + year + " " + time
	return result
}

function convertValidityISO(isoDateString) {
	// const dateTime = new Date(isoDateString.slice(0, -1));
	// const indiaTime = new Date(dateTime - 6 * 60 * 60 * 1000 - 30 * 60 * 1000);
	const datetime = new Date(isoDateString);
	return dateFormat(datetime)
}

const VoucherBatch = () => {
	const [showAlert, setShowAlert] = useState(false);
	const { user } = useSelector((state) => state.authReducer);
	const { user_roleid } = user;
	const { voucherBatches, voucherCodes, errors, loading, codeTotal } = useSelector((state) => {
		return {
			voucherBatches: state.voucherReducer?.voucherBatches || [],
			voucherCodes: state.voucherReducer?.voucherCodes,
			errors: state.errors,
			loading: state.loading,
			codeTotal: state?.voucherReducer?.voucherCodes?.total || 0
		}
	});


	const [page, setPage] = useState(1);
	const [filterData, setFilterData] = useState("");

	const { offerings } = useSelector((state) => state.offeringReducer);
	const { sourceBusinesses } = useSelector(
		(state) => state.sourceBusinessReducer
	);
	const sourceBusinessList = Array.isArray(sourceBusinesses?.data)
		? sourceBusinesses.data
		: Array.isArray(sourceBusinesses)
			? sourceBusinesses
			: [];
	const offeringsList = Array.isArray(offerings?.result)
		? offerings.result
		: Array.isArray(offerings)
			? offerings
			: [];

	const { voucherBatcher, totalPages, totalActive } = useSelector((state) => {
		return {
			voucherBatcher: state?.voucherBatchReducerV3?.data?.data || [],
			loading: state?.voucherBatchReducerV3?.loading,
			totalPages: state?.voucherBatchReducerV3?.data?.totalPages  || 0,
			errors: state?.voucherBatchReducerV3?.errors,
			totalActive: state?.voucherBatchReducerV3?.data?.totalActive || 0

		}
	});


	function getSourceCollection() {
		const arr = sourceBusinessList.map((source) => ({
			id: source.brand_id,
			name: source.brand_name,
		}));
		return arr;
	}

	const dispatch = useDispatch();
	/************************************* USE EFFECT **************************************/
	useEffect(() => {
		// dispatch(getAllOfferingsV3());
		dispatch(getAllSourceBusiness());
		// dispatch(getAllVoucherBatchV3())
		dispatch(getAllOfferings());
	}, [dispatch]);


	// console.log(compaignSearch,"sourceBusinesses")
	const debouncedSearch = useDebounce(filterData, 600);

	useEffect(() => {
		setPage(1);
	}, [debouncedSearch]);

	useEffect(() => {
		dispatch(getAllVoucherBatchV3(page, 10, { search: debouncedSearch }));
	}, [debouncedSearch, page, dispatch]);

	/************************************* WIDGET DATA **************************************/
	// console.log(voucherBatcher, "voucherBatcher")
	const active = voucherBatcher && voucherBatcher
		.map((item) => item.status)
		.filter((item) => item === true);

	const [batchId, setBatchId] = useState(null);

	/************************************* VOUCHER CODES **************************************/
	const [openDialog, setOpenDialog] = useState(false);
	const handleVouchers = (id) => {
		dispatch(getVoucherCodes(id?.batch_id));
		setOpenDialog(true);
		setBatchId(id?.batch_id);
		setShowAlert(false);
	};
	const handleCloseDialog = () => {
		setOpenDialog(false);
	};

	/************************************* TABLE DATA **************************************/
	const columns = [
		{ key: "batch_id", label: "Batch ID" },
		{ key: "offering_id", label: "Offering ID" },
		{ key: "details", label: "Offering Details" },
		{ key: "brand_name", label: "Brand Name" },
		{ key: "validity", label: "Validity" },
		{ key: "offering_type", label: "Offering Type" },
		{ key: "voucher_count", label: "Voucher Count" },
		{ key: "status", label: "Status" },
		{ key: "is_verified", label: "Verified" },
	];

	const [deleteAlert, setDeleteAlert] = useState({});


	const handleDelete = (id) => {
		setDeleteAlert({ open: true, id: id });
	};

	/************************************* FORM DATA **************************************/
	const [openForm, setOpenForm] = useState(false);
	const [batch, setBatch] = useState(initialFValues);
	const [file, setFile] = useState(null);
	const [datePickerVal, setDatePickerVal] = useState(null);
	const [isEdit, setIsEdit] = useState(false);
	const [updatedVal, setUpdatedVal] = useState({});


	// const [brandValue, setBrandValue] = useState("");

	const handleOpenForm = () => {
		setOpenForm(true);
		setShowAlert(false);
	};
	const handleCloseForm = () => {
		if (isEdit) {
			setIsEdit(false);
		}
		setOpenForm(false);
		setUpdatedVal({});
		setDatePickerVal(null);
		setBatch(initialFValues);
	};
	const handleDateChange = (newValue) => {
		const dateTime = new Date(newValue);

		const pad = (n) => n.toString().padStart(2, '0');

		const date = `${dateTime.getFullYear()}-${pad(dateTime.getMonth() + 1)}-${pad(dateTime.getDate())}`;
		const time = `${pad(dateTime.getHours())}:${pad(dateTime.getMinutes())}:00`;
		const validity = `${date} ${time}`;

		setDatePickerVal(newValue);

		if (isEdit) {
			setUpdatedVal({ ...updatedVal, validity });
		}

		setBatch({
			...batch,
			validity,
		});
	};

	const handleFileUpload = (e) => {
		setFile(e.target.files[0]);
	};

	const handleBrandClick = (obj) => {

		if (!obj) {
			setBatch({
				...batch,
				brand_name: "",
			});
			setUpdatedVal({ ...updatedVal, brand_name: "" });
		} else {
			setBatch({
				...batch,
				brand_id: obj.id,
			});
			setUpdatedVal({ ...updatedVal, brand_name: obj.name });
		}
	};
	const handleOfferClick = (obj) => {
		if (!obj) {
			setBatch({
				...batch,
				offering_id: "",
			});
			setUpdatedVal({ ...updatedVal, offering_id: "" });
		} else {
			setBatch({
				...batch,
				offering_id: obj.id,
			});
			setUpdatedVal({ ...updatedVal, offering_id: obj.id });
		}
	};


	const [batchDublicate, setBatchDuplicate] = useState(false);
	const [showModal, setShowModal] = useState(true);
	const [dublicateData, setDublicateData] = useState({})


	const handleSubmit = async (e) => {
		e.preventDefault();
		// dispatch(showLoading(true));
		if (isEdit) {
			const validity = {
				validity: updatedVal.validity,
				status:true
			}
			dispatch(updateVoucherBatch(updatedVal.batch_id?.batch_id, validity, "voucher-update"));
			setIsEdit(false);
			setShowAlert(true);
			setUpdatedVal({});
			setBatch(initialFValues);
			setDatePickerVal(null);
			setFile(null);
			handleCloseForm();
		} else {
			const formData = new FormData();
			if (!file) {
				toast.error("Please upload a batch file.");
				return;
			}
			formData.append("batch_file", file);

			for (let item in batch) {
				formData.append(item, batch[item]);
			}
			formData.delete("brand_name");
			formData.delete("status");
			dispatch(createVoucherBatchV3(formData)).then((res) => {
				if (res?.data?.duplicateCodes?.length > 0) {
					setBatchDuplicate(true);
					setDublicateData(res?.data?.duplicateCodes);
				} else if (res?.message === "Mismatch in consumption_type. Offering expects \"Dynamic\", but sheet contains different values: [Generic]") {
					toast.error("Mismatch in consumption_type. Offering expects \"Dynamic\", but sheet contains different values: [Generic]");
					setUpdatedVal({});
					setBatch(initialFValues);
					setDatePickerVal(null);
					setFile(null);
					handleCloseForm();
				}
				else {
					setUpdatedVal({});
					setBatch(initialFValues);
					setDatePickerVal(null);
					setFile(null);
					handleCloseForm();
				}
			});
		}
	};

	// console.log(dublicateData, "dublicateData")









	const handleAccept = () => {
		const formData = new FormData();
		if (!file) {
			toast.error("Please upload a batch file.");
			return;
		}
		formData.append("batch_file", file);

		for (let item in batch) {
			formData.append(item, batch[item]);
		}
		formData.append("onDuplicate", "overwrite");
		formData.delete("brand_name");
		formData.delete("status");
		dispatch(createVoucherBatchV3(formData));
		setIsEdit(false);
		setShowModal(false);
		setUpdatedVal({});
		setBatch(initialFValues);
		setDatePickerVal(null);
		setFile(null);
		handleCloseForm();
	};

	const handleIgnore = () => {
		setShowModal(false);
	};



	const handleEdit = (id) => {
		const selectedBatch = id
		setBatch(selectedBatch)
		setIsEdit(true);
		handleOpenForm();
		setUpdatedVal({ ...updatedVal, ["batch_id"]: id });
	};

	const handleStatusChange = (id, status) => {

		const formData = {
			"status": status,
		};
		dispatch(updateVoucherBatch(id, formData));
	};

	const handleVerificationChange = (id, is_verified) => {
		const formData = {
			is_verified,
		};
		dispatch(updateVoucherBatch(id, formData));
	};

	/************************************* DETAIL POP UP **************************************/
	const initialPValues = {
		"Voucher Batch": "",
		"Associated Offering": "",
		"Number of Vouchers": "",
		"Batch Validity": "",
		Status: "",
		Verified: "",
		"Verified By": "",
		"Created At": "",
		"Created By": "",
		"Modified At": "",
		"Modified By": "",
	};

	const [openPopup, setOpenPopup] = useState(false);
	const [popupData, setPopupData] = useState(initialPValues);

	const getOfferingCollections = () => {
		let arr = [];

		if (isEdit) {
			arr = offeringsList
				.filter((offers) => offers.offering_id === batch.offering_id)
				.map((offering) => ({
					id: offering.offering_id,
					name: offering.details,
					source_business_id: offering.source_business_id,
					brand_name: sourceBusinessList.find(
						(obj) => obj.brand_id === offering.source_business_id
					)?.brand_name
				}));
		} else {
			arr = offeringsList.map((offering) => ({
				id: offering.offering_id,
				name: offering.details,
				source_business_id: offering.source_business_id,
				brand_name: sourceBusinessList.find(
					(obj) => obj.brand_id === offering.source_business_id
				)?.brand_name
			}));
		}

		return arr;
	};

	const handleView = async (id) => {
		const mappedBatches = voucherBatcher.map((batch) => ({
			...batch,
			batch_name_lower: batch.batch_name?.toLowerCase() || "",
		}));

		const thisBatch = mappedBatches.filter(
			(voucherBatch) => voucherBatch.batch_id === id?.batch_id
		);
		setOpenPopup(true);
		setShowAlert(false);
		setPopupData({
			"Voucher Batch ID": thisBatch[0].batch_id,
			"Brand Name": thisBatch[0].brand_name || "",
			"Brand ID": thisBatch[0].brand_id,
			"Associated Offering ID": thisBatch[0].offering_id,
			"Number of Vouchers": thisBatch[0].voucher_count,
			"Batch Validity": convertValidityISO(thisBatch[0].validity),
			Status: thisBatch[0].status ? "Active" : "Inactive",
			Verified: thisBatch[0].is_verified ? "Yes" : "No",
		});

	};
	const handleClosePopup = () => {
		setOpenPopup(false);
	};


	if (loading) {
		return <Loader status={"Loading"} />
	}

	const deleteOffer = async () => {
		dispatch(deleteVoucherBatch(deleteAlert.id, user.user_id));
		setDeleteAlert({});
		// toast.success("Batch deleted successfully!", { position: "top-center" });
	}


	const onPageChange = (newPage) => {
		if (newPage !== page) {
			setPage(newPage); // ✅ Update page
		}
	};


	return (
		<Container className='voucher-batch'>
			<Grid container direction='column' spacing={5}>
				<Grid item>
					<motion.div
						className="voucher-batch-intro"
						initial={{ opacity: 0, y: -16 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.45, ease: "easeOut" }}
					>
						<h2>Voucher Batch Overview</h2>
						<p>
							Create and manage voucher batches, then review status and voucher codes from one place.
						</p>
					</motion.div>
				</Grid>
				{/***********************  Widgets ************************/}
				<Grid
					container
					item
					direction='row'
					justifyContent=''
					gap={5}>
					<TotalCard text={`Total: ${totalPages}`} icons={<ConfirmationNumber fontSize="medium" repeat={0} />} color={"#7469f1"} width={"350px"} />
					<TotalCard text={`Active: ${totalActive}`} icons={<ConfirmationNumber fontSize="medium" repeat={0} />} color={"#7469f1"} width={"350px"} />
				</Grid>

				{/***********************  Display voucher batch and create new ************************/}
				<Grid item>
					{(user_roleid === 1 || user_roleid === 2 || user_roleid === 3) &&
						<CreateCampaignCard onClick={handleOpenForm} btnText={"Create new"} heading={"Create New Voucher Batch"} />
					}
					{
						loading ?
							<CommonDataTableShimmer count={10} /> :
							<div className="pt-10">
								<CommonDataTable
								data={voucherBatcher}
								onView={handleView}
								onEdit={handleEdit}
								onDelete={handleDelete}
								onToggleStatus={handleStatusChange}
								onToggleVerified={handleVerificationChange}
								currentPage={page}
								onPageChange={(newPage) => onPageChange(newPage)}
								showSearch={true}
								totalPages={totalPages}
								setCompaignForSearch={setFilterData}
								compaignSearch={filterData}
								columns={columns}
								handleCopy={handleVouchers}
								searchText={`Search by Offering ID,Brand Id and Brand Name...`}
							/>
							</div>
					}
				</Grid>
			</Grid>

			{/***********************  Voucher Form ************************/}
			<Dialog
				open={openForm}
				onClose={handleCloseForm}
				TransitionComponent={Transition}
				fullWidth
				maxWidth='xl'
				scroll='paper'
				PaperProps={{
					sx: {
						borderRadius: 3,
						overflow: "hidden",
						maxHeight: "92vh",
						border: "1px solid rgba(148, 163, 184, 0.35)",
						background: "#ffffff",
					},
				}}
				BackdropProps={{
					sx: {
						backdropFilter: "blur(6px)",
						backgroundColor: "rgba(2, 6, 23, 0.6)",
					},
				}}
			>
				<AppBar
					sx={{
						position: "relative",
						background:
							"linear-gradient(90deg, #1d4ed8 0%, #2563eb 50%, #06b6d4 100%)",
					}}
				>
					<Toolbar>
						<IconButton
							edge='start'
							color='inherit'
							onClick={handleCloseForm}
							aria-label='close'>
							<Close />
						</IconButton>
						<Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
							{isEdit ? "Edit Voucher Batch" : "Add new Voucher Batch"}
						</Typography>
						<Button autoFocus color='inherit' disabled={(!file && !isEdit) || loading} onClick={handleSubmit} sx={{ background: 'linear-gradient(135deg, #ffffff 30%, #f0f0f0 90%)', color: '#2f2b3de6', transition: 'all 0.3s ease', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.5)', width: '250px' }}>
							{isEdit ? "Update Voucher Batch" : "Save Voucher Batch"}
						</Button>
					</Toolbar>
				</AppBar>
				<DialogContent
					dividers
					sx={{
						p: 0,
						overflowX: "hidden",
						overflowY: "auto",
						maxHeight: "calc(92vh - 64px)",
					}}
				>
					{
						loading ? (isEdit ? <Loader status={"Updating"} /> : <Loader status={"Creating"} />)
							: (<>

								<form action=''>
									<Box
										sx={{
											"& .MuiTextField-root": { mt: 4, ml: 7, width: "80%" },
										}}>
										<Grid container direction='row'>

										{!isEdit && (
											<>
												<Grid item xs={6}>
													<Autocomplete
														error={!batch.brand_name ? false : true}
														defaultValue={() => {
															if (isEdit) {
																let arr = getSourceCollection()?.filter(obj => obj.name == batch.brand_name)
																return arr[0]
															}

														}}
														id="combo-box"
														sx={{ m: 0, ml: 0, p: 0, width: "auto" }}
														options={
															(isEdit) ?
																(getSourceCollection()?.filter(obj => obj.name == batch.brand_name))
																: getSourceCollection()
														}
														getOptionLabel={option => option?.name}
														renderInput={(params) => (
															<TextField
																{...params}
																label="Brands"
															/>
														)}
														onChange={(e, value, reason) => {
															// handleInputChange(value)
															if (!isEdit) {
																handleBrandClick(value)
															}
														}}
													/>
													<Autocomplete
														error={!batch.offering_id ? false : true}
														defaultValue={() => {
															if (isEdit) {
																let arr = getOfferingCollections()?.filter(obj => obj.id == batch.offering_id)
																return arr[0]
															} else if (!isEdit) {
																return {
																	id: "",
																	name: ""
																}
															}
														}}
														id="combo-box"
														sx={{ m: 0, ml: 0, p: 0, width: "auto" }}
														options={
															isEdit
																? getOfferingCollections()?.filter(obj => String(obj.id) === String(batch.offering_id))
																: getOfferingCollections()?.filter(obj => obj.brand_name === updatedVal.brand_name)
														}
														getOptionLabel={(option) =>
															option && typeof option === "object"
																? `[${option.id}] - ${option.name || ""}`
																: ""
														}
														renderInput={(params) => (
															<TextField
																{...params}
																label="Associated Offering"
															/>
														)}
														onChange={(e, value, reason) => {
															// handleInputChange(value)
															if (!isEdit) {
																handleOfferClick(value)
															}
														}}
													/>
												</Grid>

												<Grid item xs={6}>
													<Stack
														sx={{ ml: 7, mt: 5 }}
														direction='row'
														alignItems='center'
														spacing={2}>
														<Button
															variant='contained'
															startIcon={<FileUpload />}
															type='upload'
															component='label'
															onChange={handleFileUpload}>
															<input hidden accept='.xlsx' type='file' />
															Upload new batch
														</Button>
														<Button
															variant='outlined'
															startIcon={<Download />}
															type='download'
															component='label'
															onClick={handleDownload}>
															Sample sheet format
														</Button>
													</Stack>
												</Grid>
											</>
										)}

										<Grid item xs={6}>
											<LocalizationProvider dateAdapter={AdapterDayjs}>

												<DateTimePicker
													label="Validity"
													disablePast
													value={batch.validity || null}
													onChange={handleDateChange}
													renderInput={(params) => {
														const isPastDate = batch?.validity && new Date(batch.validity) < new Date();
														return (
															<TextField
																{...params}
																error={!!isPastDate}
																helperText={isPastDate ? "Validity date/time must be in the future" : ""}
															/>
														);
													}}
												/>
											</LocalizationProvider>
										</Grid>
									</Grid>
								</Box>
							</form>
							{
								!isEdit && (
									<div className="bg-yellow-100 border border-black text-center rounded-lg p-4 mb-6 mt-32">
										<h2 className="text-red-600 font-bold text-lg mb-2">
											⚠️ Upload Voucher Code Rule
										</h2>
										<p className="text-brown-800 text-sm">
											You <strong>cannot upload the same voucher code</strong> in different offerings under the same brand.
											<br />
											<strong>For example:-</strong> If a voucher code has already been uploaded to one offering of <strong>Nike Brand</strong>,
											it <strong>cannot</strong> be uploaded again to any other offering under <strong>Nike Brand</strong>.
											<br />
											<br />
											📌 Please make sure the voucher codes are <strong>unique across all offerings</strong> of the selected brand.
										</p>
									</div>
								)
							}
							</>)
					}
				</DialogContent>
				{
					batchDublicate && (
						<>
							<DuplicateCodesModal
								isOpen={showModal}
								codes={dublicateData}
								onAccept={handleAccept}
								onIgnore={handleIgnore}
							/>
						</>
					)
				}
			</Dialog>


			{/***********************  Voucher codes dialog ************************/}
			<Dialog
				open={openDialog}
				onClose={handleCloseDialog}
				TransitionComponent={Transition}
				fullWidth
				maxWidth='xl'
				scroll='paper'
				PaperProps={{
					sx: {
						borderRadius: 3,
						overflow: "hidden",
						maxHeight: "92vh",
						border: "1px solid rgba(148, 163, 184, 0.35)",
						background: "#ffffff",
					},
				}}
				BackdropProps={{
					sx: {
						backdropFilter: "blur(6px)",
						backgroundColor: "rgba(2, 6, 23, 0.6)",
					},
				}}
			>
				<AppBar
					sx={{
						position: "relative",
						background:
							"linear-gradient(90deg, #1d4ed8 0%, #2563eb 50%, #06b6d4 100%)",
					}}
				>
					<Toolbar>
						<IconButton
							edge='start'
							color='inherit'
							onClick={handleCloseDialog}
							aria-label='close'>
							<Close />
						</IconButton>
						<Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
							Voucher Codes
						</Typography>
					</Toolbar>
				</AppBar>
				<DialogContent
					dividers
					sx={{
						p: 0,
						overflowX: "hidden",
						overflowY: "auto",
						maxHeight: "calc(92vh - 64px)",
					}}
				>
					<Voucher batchId={batchId} />
				</DialogContent>
			</Dialog>

			{/***********************  Detailed voucher popup ************************/}
			<Dialog
				sx={{
					"& .MuiDialog-paper": {
						width: "55%",
						maxHeight: 500,
						borderRadius: '12px',
						boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
						background: 'linear-gradient(135deg, #ffffff, #f9f9f9)',
					}
				}}
				maxWidth='md'
				open={openPopup}
			>
				<Toolbar
					sx={{
						backgroundColor: '#4a148c',
						color: '#fff',
						borderTopLeftRadius: '12px',
						borderTopRightRadius: '12px',
					}}
				>
					<Typography sx={{ flex: 1, fontWeight: 600 }} variant='h6' component='div'>
						🎫 Voucher Batch Details
					</Typography>
					<IconButton edge='end' color='inherit' onClick={handleClosePopup} aria-label='close'>
						<Close />
					</IconButton>
				</Toolbar>

				<DialogContent dividers sx={{ padding: '1.5rem', overflowY: 'auto' }}>
					{Object.entries(popupData).map(([key, value], index) => (
						<Box key={index} mb={2}>
							<Grid container alignItems="center">
								<Grid item xs={4}>
									<Typography variant='subtitle2' sx={{ fontWeight: 600, color: '#4a148c' }}>
										{key}:
									</Typography>
								</Grid>
								<Grid item xs={8}>
									<Typography variant='body2' sx={{ color: '#333' }}>
										{value}
									</Typography>
								</Grid>
							</Grid>
							{index < Object.entries(popupData).length - 1 && <Divider sx={{ mt: 1 }} />}
						</Box>
					))}

				</DialogContent>
			</Dialog>

			{/***********************  Alert ************************/}
			{
				deleteAlert?.id && (
					<MessageDialog
						open={deleteAlert}
						onClose={() => setDeleteAlert(false)}
						title="Are you sure want to delete this Batch?"
						message={`Are you sure you want to delete this batch ${deleteAlert?.id?.brand_name}?`}
						okText={`Delete`}
						variant={"error"}
						img={`https://storage.googleapis.com/public-images-plutosone/cbms/campaign/image-1748122267846-assets_task_01jw2360pqec98vpmf1vxzjzrm_1748122215_img_2.webp`}
						onConfirm={deleteOffer}
					/>
				)
			}



		</Container>
	);
};

export default VoucherBatch;
